import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as MainSearchActions from "../actions";
import type { IMainSearchQueryState } from "../types";

const initialState: IMainSearchQueryState = {
  textValueMainSearch: "",
  textValueSuggestionSearch: "",
  mainSearchResultsCount: 0,
  mainSearchSuggestionResultsCount: 0,
  isFetchingSearchSuggestions: false
};

export default function mainSearchQueryReducer(
  state: IMainSearchQueryState = initialState,
  action: ActionType<typeof MainSearchActions>
): IMainSearchQueryState {
  switch (action.type) {
    case getType(MainSearchActions.setSearchText):
      return { ...state, textValueMainSearch: action.payload };

    case getType(MainSearchActions.setSuggestionsSearchText):
      return { ...state, textValueSuggestionSearch: action.payload, isFetchingSearchSuggestions: true };

    case getType(MainSearchActions.setMainSearchResultsCount):
      return { ...state, mainSearchResultsCount: action.payload };

    case getType(MainSearchActions.setMainSearchSuggestionResultsCount):
      return { ...state, mainSearchSuggestionResultsCount: action.payload, isFetchingSearchSuggestions: false };

    case getType(MainSearchActions.resetSearch):
      return { ...state, textValueMainSearch: "", mainSearchResultsCount: 0 };

    case getType(MainSearchActions.resetSuggestionsSearch):
      return { ...state, textValueSuggestionSearch: "", mainSearchSuggestionResultsCount: 0 };
    default:
      return state;
  }
}
